import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from "./supabaseClient"

const V = "#7C3AED"
const WHITE = "#FFFFFF"
const TEXT = "#09090B"
const MUTED = "#71717A"
const BORDER = "#E4E4E7"
const SOFT = "#F7F4FF"

const H = "'Plus Jakarta Sans', system-ui, sans-serif"
const B = "'Manrope', system-ui, sans-serif"

export default function KorivaBienvenida() {
  const navigate = useNavigate()
  const [lang, setLang] = useState("es")
  const [verificando, setVerificando] = useState(true)
  const es = lang === "es"

  useEffect(() => {
    const verificar = async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) { navigate('/login', { replace: true }); return }

      const metaLang = (session.user.user_metadata || {}).lang
      if (metaLang) setLang(metaLang)

      const { data: proyectos } = await supabase
        .from("projects")
        .select("id, brand_forms(id)")
        .eq("user_id", session.user.id)

      const conMarca = (proyectos || []).some(p => p.brand_forms && (Array.isArray(p.brand_forms) ? p.brand_forms.length > 0 : true))
      if (conMarca) {
        navigate('/dashboard', { replace: true })
        return
      }

      if (!proyectos || proyectos.length === 0) {
        const meta = session.user.user_metadata || {}
        if (meta.bname && meta.biz) {
          await supabase.from("projects").insert({
            user_id: session.user.id,
            nombre: meta.bname,
            tipo_negocio: meta.biz,
            activo: true
          })
          if (meta.terms_ok) {
            await supabase.from("users")
              .update({ terms_accepted_at: new Date().toISOString(), terms_version: "2026-08-17", lang: meta.lang || "es" })
              .eq("id", session.user.id)
          }
        }
      }
      setVerificando(false)
    }
    verificar()
  }, [navigate])

  if (verificando) return <div style={{ background: WHITE, minHeight: "100vh" }} />

  const t = {
    titulo: es ? "Te damos la bienvenida a KORIVA " : "Welcome to KORIVA ",
    sub: es ? "Desde hoy, tu marca tiene un equipo creativo." : "From today, your brand has a creative team.",
    intro: es
      ? "Guardamos quién eres y cada semana te proponemos qué decir, a quién hablarle y cómo mostrarlo, sin que empieces de cero. Pero antes de empezar, necesitamos conocer tu negocio, tu proyecto o tu idea."
      : "We remember who you are, and every week we suggest what to say, who to say it to and how to show it, so you never start from zero. But first, we need to know your business, your project or your idea.",
    citaTitulo: es ? "Nadie conoce tu marca como tú." : "Nobody knows your brand like you do.",
    citaTexto: es
      ? "Qué vendes, para quién es y por qué te eligen a ti. Eso no se inventa: lo sabes tú, y es lo que hace que tu contenido se parezca a tu marca y no a cualquier otra."
      : "What you sell, who it's for and why they choose you. That can't be invented: you already know it, and it's what makes your content look like your brand and not like anyone else's.",
    construyePre: es ? "Con esa información, " : "With that, ",
    construyePost: es ? " construye" : " builds",
    c1t: es ? "El ADN de tu marca" : "Your brand DNA",
    c1s: es ? "Qué la hace distinta y cómo se ve" : "What sets it apart and how it looks",
    c2t: es ? "Tus buyer personas" : "Your buyer personas",
    c2s: es ? "A quién le hablas y cómo decide" : "Who you speak to and how they decide",
    c3t: es ? "Tu voz" : "Your voice",
    c3s: es ? "Cómo suena tu marca cuando habla" : "How your brand sounds when it speaks",
    desdeAhi: es
      ? "Y desde ahí, cada semana: la estrategia, los conceptos y las imágenes."
      : "And from there, every week: the strategy, the concepts and the images.",
    formNegrita: es ? "El formulario tiene ocho secciones." : "The form has eight sections.",
    formResto: es
      ? " Se llena una sola vez y de ahí sale todo lo demás. Toma un máximo de 25 minutos y hay que terminarlo de corrido: si sales antes del final, hay que empezar de nuevo. Vale la pena hacerlo con calma."
      : " You fill it once, and everything else comes from it. It takes 25 minutes at most and needs to be completed in one go: if you leave before the end, you start over. It's worth taking your time.",
    cta: es ? "Empecemos →" : "Let's begin →"
  }

  const tarjetas = [
    { n: "01", t: t.c1t, s: t.c1s },
    { n: "02", t: t.c2t, s: t.c2s },
    { n: "03", t: t.c3t, s: t.c3s }
  ]

  return (
    <div style={{ background: WHITE, minHeight: "100vh", fontFamily: B, color: TEXT }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&family=Manrope:wght@300;400;500;600&display=swap');
        .bcta:hover{opacity:.9}
        @media(max-width:768px){
          .bwrap{padding:1.5rem 1.25rem 3rem!important}
          .bh1{font-size:28px!important}
          .bcards{flex-direction:column!important}
        }
      `}</style>

      <div className="bwrap" style={{ maxWidth: 760, margin: "0 auto", padding: "2rem 2rem 4rem" }}>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "1.75rem", borderBottom: `1px solid ${BORDER}` }}>
          <span style={{ fontFamily: H, fontSize: 15, fontWeight: 800, letterSpacing: ".14em", color: TEXT }}>
            KORIVA <span style={{ color: V }}>STUDIO<span style={{ fontSize: ".45em", verticalAlign: "super", fontWeight: 600, letterSpacing: 0, marginLeft: "2px" }}>™</span></span>
          </span>
          <div style={{ display: "flex", gap: 6 }}>
            {["es", "en"].map(l => (
              <button key={l} onClick={() => setLang(l)}
                style={{ background: "none", border: `1px solid ${lang === l ? V : BORDER}`, color: lang === l ? V : MUTED, borderRadius: 6, padding: "3px 10px", fontSize: 11, cursor: "pointer", fontFamily: B, fontWeight: lang === l ? 700 : 400, textTransform: "uppercase" }}>{l}</button>
            ))}
          </div>
        </div>

        <h1 className="bh1" style={{ fontFamily: H, fontSize: 34, fontWeight: 800, lineHeight: 1.2, letterSpacing: "-.02em", color: TEXT, margin: "2.25rem 0 .6rem" }}>
          {t.titulo}<span style={{ color: V }}>Studio</span>
        </h1>
        <p style={{ fontSize: 16, color: MUTED, margin: "0 0 1.5rem" }}>{t.sub}</p>

        <p style={{ fontSize: 16, lineHeight: 1.7, color: TEXT, margin: "0 0 1.75rem" }}>{t.intro}</p>

        <div style={{ borderLeft: `2px solid ${V}`, padding: "2px 0 2px 18px", margin: "0 0 2rem" }}>
          <p style={{ fontFamily: H, fontSize: 19, fontWeight: 700, color: TEXT, margin: "0 0 .5rem" }}>{t.citaTitulo}</p>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: MUTED, margin: 0 }}>{t.citaTexto}</p>
        </div>

        <p style={{ fontFamily: H, fontSize: 16, fontWeight: 700, color: TEXT, margin: "0 0 1.4rem" }}>
          {t.construyePre}<span style={{ color: V }}>KORIVA</span>{t.construyePost}
        </p>

        <div className="bcards" style={{ display: "flex", gap: 16, margin: "0 0 1.9rem" }}>
          {tarjetas.map(c => (
            <div key={c.n} style={{ flex: 1, background: SOFT, borderRadius: 12, padding: "18px 18px 20px" }}>
              <span style={{ fontFamily: H, fontSize: 22, fontWeight: 800, color: V }}>{c.n}</span>
              <p style={{ fontSize: 15, fontWeight: 600, color: TEXT, margin: ".6rem 0 .4rem" }}>{c.t}</p>
              <p style={{ fontSize: 13, lineHeight: 1.6, color: MUTED, margin: 0 }}>{c.s}</p>
            </div>
          ))}
        </div>

        <p style={{ fontSize: 15, lineHeight: 1.7, color: MUTED, margin: "0 0 1.9rem" }}>{t.desdeAhi}</p>

        <p style={{ fontSize: 15, lineHeight: 1.7, color: TEXT, margin: "0 0 1.7rem" }}>
          <span style={{ fontWeight: 600 }}>{t.formNegrita}</span>
          <span style={{ color: MUTED }}>{t.formResto}</span>
        </p>

        <button className="bcta" onClick={() => navigate('/brand-form')}
          style={{ background: V, color: WHITE, border: "none", borderRadius: 8, padding: "13px 30px", fontFamily: H, fontSize: 15, fontWeight: 700, cursor: "pointer", transition: "opacity .18s" }}>
          {t.cta}
        </button>

      </div>
    </div>
  )
}
